const url = 'https://mirawebbackend.vercel.app';

const Urls = {
    POSTEMAIL: `${url}/api/emailsignup/`,
}

export default Urls;